/**
 * Design Tokens - Colors
 * Raw brand and utility scales are defined first,
 * followed by semantic aliases consumed by components.
 */

export const COLORS = {
  accent: {
    // greens
    'green-100': 'var(--color-accent-green-100)',
    'green-300': 'var(--color-accent-green-300)',
    'green-500': 'var(--color-accent-green-500)',
    'border-green': 'var(--color-accent-border-green)',
    'status-green': 'var(--color-accent-status-green)',
    'surface-green': 'var(--color-accent-surface-green)',

    // reds
    'red-500': 'var(--color-accent-red-500)',
    'border-red': 'var(--color-accent-border-red)',
    'status-red': 'var(--color-accent-status-red)',
    'surface-red': 'var(--color-accent-surface-red)',

    // oranges/yellows
    'orange-300': 'var(--color-accent-orange-300)',
    'yellow-100': 'var(--color-accent-yellow-100)',
    'border-yellow': 'var(--color-accent-border-yellow)',
    'status-yellow': 'var(--color-accent-status-yellow)',
    'surface-orange': 'var(--color-accent-surface-orange)',
    'surface-yellow': 'var(--color-accent-surface-yellow)',

    // misc
    'blue-100': 'var(--color-accent-blue-100)',
    'blue-300': 'var(--color-accent-blue-300)',
    'blue-500': 'var(--color-accent-blue-500)',
    'purple-100': 'var(--color-accent-purple-100)',
    'purple-300': 'var(--color-accent-purple-300)',
    'purple-500': 'var(--color-accent-purple-500)',
  },
  brand: {
    'primary-100': 'var(--color-brand-primary-100)',
    'primary-200': 'var(--color-brand-primary-200)',
    'primary-300': 'var(--color-brand-primary-300)',
    'primary-400': 'var(--color-brand-primary-400)',
    'primary-500': 'var(--color-brand-primary-500)',
    'primary-600': 'var(--color-brand-primary-600)',
    'primary-700': 'var(--color-brand-primary-700)',
    'primary-800': 'var(--color-brand-primary-800)',
    'primary-900': 'var(--color-brand-primary-900)',
    'primary': 'var(--color-brand-primary)',
  },
  neutral: {
    'gray-000': 'var(--color-neutral-gray-000)',
    'gray-100': 'var(--color-neutral-gray-100)',
    'gray-200': 'var(--color-neutral-gray-200)',
    'gray-300': 'var(--color-neutral-gray-300)',
    'gray-400': 'var(--color-neutral-gray-400)',
    'gray-500': 'var(--color-neutral-gray-500)',
    'gray-600': 'var(--color-neutral-gray-600)',
    'gray-700': 'var(--color-neutral-gray-700)',
    'gray-800': 'var(--color-neutral-gray-800)',
    black: 'var(--color-neutral-black)',
    white: 'var(--color-neutral-white)',
  },
  system: {
    'error': 'var(--color-system-error)',
    'success': 'var(--color-system-success)',
    'warning': 'var(--color-system-warning)',
  },
  semantic: {
    buttons: {
      'inactive-background': 'var(--color-semantic-button-inactive-background-color)',
      'inactive-text': 'var(--color-semantic-button-inactive-text-color)',
    },
    globals: {
      'border': 'var(--color-semantic-global-border-color)',
      'page-background': 'var(--color-semantic-global-page-background-color)',
      'page-content-background': 'var(--color-semantic-global-page-content-background-color)',
    },
    text: {
      'primary': 'var(--color-semantic-text-color-primary)',
      'secondary': 'var(--color-semantic-text-color-secondary)',
    },
    score: {
      'l1': 'var(--color-semantic-score-l1)',
      'l2': 'var(--color-semantic-score-l2)',
      'l3': 'var(--color-semantic-score-l3)',
      'l4': 'var(--color-semantic-score-l4)',
      'legacy-l1': 'var(--color-semantic-score-legacy-l1)',
      'legacy-l2': 'var(--color-semantic-score-legacy-l2)',
      'legacy-l3': 'var(--color-semantic-score-legacy-l3)',
      'legacy-l4': 'var(--color-semantic-score-legacy-l4)',
    }
  },
} as const;
